module.exports = __webpack_public_path__ + "static/media/crying-emoji-emoticon-emotion-expression-smiley-svgrepo-com.0b2c1fe1.svg";